export default "__VITE_ASSET___m7cscEu__"